import { createAction } from '../../utils/redux/createAction';
import { ACTIVITY_TYPES } from '../../constants';

const actionsScope = 'communities/activities';

export const ACTIVITIES_TYPES = {
  CHANGE_TAB: `${actionsScope}/change-tab`,
};

export const activitiesActions = {
  changeTab: createAction(ACTIVITIES_TYPES.CHANGE_TAB),
};

const initialState = {
  activeTab: ACTIVITY_TYPES.NOTIFICATIONS,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTIVITIES_TYPES.CHANGE_TAB: {
      return {
        ...state,
        activeTab: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/communities/activities.js